import { useEffect, useState } from 'react';
import { Record, RecordDraft } from '../../types/sharedTypeImpl.ts';


interface Props {
    record: RecordDraft;
    prevRecord: Record | undefined;
    isViewMode: boolean;
    isFinishedRecord: boolean;
}

// If the part count is lower than the previous record's part count, that implies
// that a new order has been started. Prompt the user to validate the order number and target quantity.
export function useNewOrderWarning({
    record,
    prevRecord,
    isViewMode,
    isFinishedRecord,
}: Props) {
    const [isCheckDone, setIsCheckDone] = useState(false);
    const [shouldShowAlert, setShouldShowAlert] = useState(false);

    useEffect(() => {
        if (!isCheckDone &&
            record.partCount != null &&
            prevRecord?.partCount != null &&
            prevRecord.partCount > record.partCount &&
            !isViewMode &&
            !isFinishedRecord
        ) {
            setShouldShowAlert(true);
        }
        if (prevRecord) {
            setIsCheckDone(true);
        }
    }, [isCheckDone, isViewMode, isFinishedRecord, record, prevRecord]);

    // Use separate useEffect to avoid showing a double alert in strict mode
    useEffect(() => {
        if (shouldShowAlert) {
            alert('The part count is lower than the previous record\'s. Validate order number and target quantity.');
            setShouldShowAlert(false);
        }
    }, [shouldShowAlert]);

}
